import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'getHoldStatus' })
export class GetHoldStatusPipe implements PipeTransform {

    transform(value: number): string {

        switch ( value ) {
            case 0:
				return 'N/A';
				
            case 1:
                return 'Active Hold';
			
				case 2:
                return 'License Resumed';

            case 3:
                return 'Hold Finished';
            case 4:
                return 'Hold Declined';
            case 5:
                return 'Hold Cancelled';

            default:
                return 'N/A'
        }

    }

}

